import React, { forwardRef } from "react";
import SelectOption from "../../../../../../components/SelectOption";
import { useApi } from "../../../../../../hooks/http2";
import { URL_API, _ } from "../../../../../../utils";

const SelectDeliveryType = (props) => {
  const list = useApi(
    {
      url: `${URL_API}/system/master/delivery_type`,
      token: true,
    },
    []
  );

  return (
    <SelectOption
      loading={list.loading}
      data={_.map(list.fetch?.data || [], (n) => ({
        value: n.code,
        text: n.name,
      }))}
      withAll
      allText={
        (list.fetch?.data || []).length > 0
          ? "เลือกการคำนวณค่าจัดส่ง"
          : "-- ไม่มีข้อมูล --"
      }
      {...props}
    />
  );
};

export default forwardRef((props, ref) => {
  return <SelectDeliveryType forwardRef={ref} {...props} />;
});
